import type { QueryMeta } from '../fetch';

const API_PREFIX = '/api/';
const PUBLIC_API_PREFIX = '/api-endpoint/external/';

/**
 * Replaces the last occurrence of /api/ in the given pathname string with the target prefix.
 * This preserves any /api/ in the path prefix (e.g. basePath or api domain path),
 * since the last /api/ is always the real API segment.
 */
export function replaceLastApiPath(pathname: string, targetPrefix: string): string {
  const idx = pathname.lastIndexOf(API_PREFIX);
  if (idx === -1) return pathname;
  return pathname.slice(0, idx) + targetPrefix + pathname.slice(idx + API_PREFIX.length);
}

/**
 * Converts the given URL to a public API URL (/api-endpoint/external/...)
 * PrivateInterface -> apis start with /api/...
 * PublicInterface -> apis start with /api-endpoint/external/...
 * The last /api/ segment in the pathname is converted so that any /api/ in the path prefix (e.g. basePath or api domain path) is preserved.
 * @param urlObj - The URL to convert in string
 * @param queryMeta - Optional metadata for the query (kept for backward compatibility; unused after replace-last simplification)
 */
// queryMeta kept for backward compatibility; unused after replace-last simplification
export const getPublicApiURL = (urlObj: URL, _queryMeta?: QueryMeta): URL => {
  urlObj.pathname = replaceLastApiPath(urlObj.pathname, PUBLIC_API_PREFIX);
  return urlObj;
};
